export const passwordRegex = { value: /^[a-zA-Z0-9.!#$%&@’*+/=?^_`{|}~-]{8}/, errorText: 'Password Should Contain Atleast 8 characters' }
export const emailRegex = {
    value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    errorText: 'Invalid Email'
};
export const numberRegex = { value: /^[0-9]*$/, errorText: 'Invalid Number', name: 'numberRegex' };
export const amountRegex = { value: /^\d+(,\d{3})*(\.\d{1,2})?$/, errorText: 'Invalid Amount' };
export const nameRegex = { value: /^[a-zA-Z ]*$/, errorText: 'Only Alphabets are allowed' };
export const nameAndNumberRegex = { value: /^[a-zA-Z0-9. ]*$/, errorText: 'Only Alpha Numerics are allowed' };

